export default {
    data () {
        return {
            selectedLeaseContactGroup: null,
        };
    },
    methods: {
        setSelectedContactGroup (value) {
            this.selectedLeaseContactGroup = value;
            if (this.mutableTicket){
                this.mutableTicket.lease_contact_group = this.selectedLeaseContactGroup;
            }
        },
    }
};
